import React, { useEffect, useState, Fragment } from "react";
import { useNavigate } from 'react-router-dom';
import axios from "axios";
import { API_BASE_URL } from "../config/api";
import { Doughnut, Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
  CategoryScale,
  LinearScale,
  BarElement,
} from "chart.js";
import * as XLSX from "xlsx";
import {
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  CardTitle,
  Row,
  Col,
  Table,
  Form,
  FormGroup,
  Input,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import "../assets/css/style.css";
import defaultAvatar from "../assets/img/man.png";

ChartJS.register(ArcElement, Tooltip, Legend, CategoryScale, LinearScale, BarElement);

function UserManagement() {

  // State variables for users, loading, and other necessary data
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [newUser, setNewUser] = useState({
    fullName: "",
    email: "",
    Image: "",
    PhoneNumber: "",
    gender: "",
    birthdate: "",
    nationality: "",
    city: "",
  });
  const [selectedUserId, setSelectedUserId] = useState(null);
  const [showMembersOnly, setShowMembersOnly] = useState(false);
  const [showStatsModal, setShowStatsModal] = useState(false);
  const [isAddMemberModalOpen, setIsAddMemberModalOpen] = useState(false);
  const [memberUserId, setMemberUserId] = useState(null);
  const [memberForm, setMemberForm] = useState({
    fullName: "",
    gender: "",
    birthdate: "",
  });
  const [memberImage, setMemberImage] = useState(null);
  const [memberError, setMemberError] = useState("");

const toggleMembersVisibility = () => {
  setShowMembersOnly(!showMembersOnly);
};

const toggleMemberDisplay = (userId) => {
  setSelectedUserId(selectedUserId === userId ? null : userId); // Toggle the display of members
};

const openAddMemberModal = (userId) => {
  setMemberUserId(userId);
  setMemberForm({
    fullName: "",
    gender: "",
    birthdate: "",
  });
  setMemberImage(null);
  setMemberError("");
  setIsAddMemberModalOpen(true);
};

const closeAddMemberModal = () => {
  setIsAddMemberModalOpen(false);
};

const handleMemberInputChange = (e) => {
  const { name, value } = e.target;
  setMemberForm((prev) => ({ ...prev, [name]: value }));
};

const handleAddMemberSubmit = async (e) => {
  e.preventDefault();
  setMemberError("");

  if (!memberUserId) {
    setMemberError("Please select a user first.");
    return;
  }

  const formData = new FormData();
  formData.append("user_id", memberUserId);
  formData.append("verify", "1");
  Object.entries(memberForm).forEach(([key, value]) => {
    if (value !== undefined && value !== null && String(value).trim() !== "") {
      formData.append(key, value);
    }
  });
  if (memberImage) {
    formData.append("image", memberImage);
  }

  try {
    await axios.post(`${API_BASE_URL}/member/add-admin`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    closeAddMemberModal();
    fetchUsers();
  } catch (error) {
    const message =
      error?.response?.data?.errors?.message ||
      error?.response?.data?.message ||
      "Error adding member. Please try again.";
    setMemberError(message);
  }
};

const formatDate = (value) => {
  if (!value) return "";
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) {
    const s = String(value);
    return s.length >= 10 ? s.slice(0, 10) : s;
  }
  return d.toISOString().slice(0, 10);
};

const resolveImageSrc = (imagePath) => {
  if (!imagePath || imagePath === "null" || imagePath === "undefined") {
    return defaultAvatar;
  }
  return `${API_BASE_URL}/uploads/${imagePath}`;
};

  const navigate = useNavigate();

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const handleExportUsers = () => {
    const rows = [];
    users.forEach((user) => {
      const parentName = user.fullName || "";
      const parentEmail = user.email || "";
      const parentPhone = user.PhoneNumber || "";
      const parentGender = user.gender || "";
      const parentBirthdate = formatDate(user.birthdate);

      rows.push({
        "Record Type": "User",
        "Parent User": "",
        "User Full Name": parentName,
        "User Email": parentEmail,
        "User Phone": parentPhone,
        "User Gender": parentGender,
        "User Birthdate": parentBirthdate,
        "Member Full Name": "",
        "Member Gender": "",
        "Member Birthdate": "",
        "Member Nationality": "",
      });

      const members = Array.isArray(user.members) ? user.members : [];
      members.forEach((member) => {
        rows.push({
          "Record Type": "Member",
          "Parent User": parentName,
          "User Full Name": "",
          "User Email": "",
          "User Phone": "",
          "User Gender": "",
          "User Birthdate": "",
          "Member Full Name": member.fullname || member.fullName || "",
          "Member Gender": member.gender || "",
          "Member Birthdate": formatDate(member.birthdate),
          "Member Nationality": member.nationality || "",
        });
      });
    });

    const worksheet = XLSX.utils.json_to_sheet(rows);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Users");
    XLSX.writeFile(workbook, "users_and_members.xlsx");
  };

  // Function to fetch the list of users
  const fetchUsers = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/user/list`);
      setUsers(response.data.data);
      setLoading(false);
    } catch (error) {
      setError("Error fetching users. Please try again later.");
      setLoading(false);
    }
  };
  
  useEffect(() => {
    fetchUsers();
  }, []);
  


  // Function to handle form submission for adding a new user
  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await axios.post(`${API_BASE_URL}/user/add`, newUser);
      console.log("User added successfully:", response.data);

      // Clear the input fields
      setNewUser({
        fullName: "",
        email: "",
        image: "",
        PhoneNumber: "",
        gender: "",
        birthdate: "",
        nationality: "",
        city: "",
      });


    
    
    

      // Fetch the updated list of users
      fetchUsers();
    } catch (error) {
      console.error("Error adding user:", error);
    }
  };

  useEffect(() => {
    fetchUsers();
  }, []);

    // Filter users based on the search term
const filteredUsers = users.filter(user => 
  user.PhoneNumber ? user.PhoneNumber.includes(searchTerm) : false
);


  return (
    <>
    <div className="content">
      <Card >
        <CardHeader>
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 12, flexWrap: "wrap" }}>
            <CardTitle tag="h4" style={{ margin: 0 }}>User List</CardTitle>
            <div style={{ display: "flex", gap: 10 }}>
              <Button color="secondary" onClick={handleExportUsers}>
                Export Users (Excel)
              </Button>
              <Button color="info" onClick={() => setShowStatsModal(true)}>
                View Statistics
              </Button>
            </div>
          </div>
        </CardHeader>
        <CardFooter>
          <div>Total Users: {users.length}</div>
        </CardFooter>

        <Row className="justify-content-center" style={{ marginTop: "22px", marginBottom: "22px" }}>
          <Col md="4" className="text-center">
            <Input
              type="text"
              placeholder="Search by Phone Number"
              value={searchTerm}
              onChange={handleSearchChange}
              style={{
                backgroundColor: "#f8f9fa",
                color: "#333",
                border: "3px solid #ced4da",
                borderRadius: "0.25rem",
              }}
            />
          </Col>
        </Row>

        <CardBody >
  <Table responsive >
    <thead className="text-primary text-center " >
      <tr>
        <th>Full Name</th>
        <th>Email</th>
        <th>Image</th>
        <th>Phone Number</th>
        <th>Gender</th>
        <th>Birthdate</th>
        <th>Nationality</th>
        <th>Actions</th>
      </tr>
    </thead>
    <tbody>
      {filteredUsers.map((user) => (
        <Fragment key={user.id}>
          <tr>
            <td className="text-center" style={{ fontSize: '13px', '@media screen and (min-width: 576px)': { fontSize: '14px' }, '@media screen and (min-width: 768px)': { fontSize: '18px' }, '@media screen and (min-width: 992px)': { fontSize: '20px' }, '@media screen and (min-width: 1200px)': { fontSize: '22px' }, '@media screen and (min-width: 1400px)': { fontSize: '24px' } }}>{user.fullName}</td>
            <td className="text-center" style={{ fontSize: '13px', '@media screen and (min-width: 576px)': { fontSize: '14px' }, '@media screen and (min-width: 768px)': { fontSize: '18px' }, '@media screen and (min-width: 992px)': { fontSize: '20px' }, '@media screen and (min-width: 1200px)': { fontSize: '22px' }, '@media screen and (min-width: 1400px)': { fontSize: '24px' } }}>{user.email}</td>
            <td className="text-center">
  <div style={{ width: 140, height: 140, overflow: 'hidden', margin: '0 auto' }}>
    <img
      src={resolveImageSrc(user.image)}
      alt={user.fullName}
     style={{ width: '80px', height: '80px', objectFit: 'cover' }}
      width="140"
      height="140"
    />
  </div>
</td>

            <td className="text-center" style={{ fontSize: '13px', '@media screen and (min-width: 576px)': { fontSize: '16px' }, '@media screen and (min-width: 768px)': { fontSize: '20px' }, '@media screen and (min-width: 992px)': { fontSize: '22px' }, '@media screen and (min-width: 1200px)': { fontSize: '24px' }, '@media screen and (min-width: 1400px)': { fontSize: '26px' } }}>{user.PhoneNumber}</td>
            <td className="text-center" style={{ fontSize: '13px', '@media screen and (min-width: 576px)': { fontSize: '16px' }, '@media screen and (min-width: 768px)': { fontSize: '20px' }, '@media screen and (min-width: 992px)': { fontSize: '22px' }, '@media screen and (min-width: 1200px)': { fontSize: '24px' }, '@media screen and (min-width: 1400px)': { fontSize: '26px' } }}>{user.gender}</td>
            <td className="text-center" style={{ fontSize: '13px', '@media screen and (min-width: 576px)': { fontSize: '16px' }, '@media screen and (min-width: 768px)': { fontSize: '20px' }, '@media screen and (min-width: 992px)': { fontSize: '22px' }, '@media screen and (min-width: 1200px)': { fontSize: '24px' }, '@media screen and (min-width: 1400px)': { fontSize: '26px' } }}>{formatDate(user.birthdate)}</td>
            <td className="text-center" style={{ fontSize: '13px', '@media screen and (min-width: 576px)': { fontSize: '16px' }, '@media screen and (min-width: 768px)': { fontSize: '20px' }, '@media screen and (min-width: 992px)': { fontSize: '22px' }, '@media screen and (min-width: 1200px)': { fontSize: '24px' }, '@media screen and (min-width: 1400px)': { fontSize: '26px' } }}>{user.nationality}</td>
            <td className="text-center" style={{ fontSize: '13px', '@media screen and (min-width: 576px)': { fontSize: '16px' }, '@media screen and (min-width: 768px)': { fontSize: '20px' }, '@media screen and (min-width: 992px)': { fontSize: '22px' }, '@media screen and (min-width: 1200px)': { fontSize: '24px' }, '@media screen and (min-width: 1400px)': { fontSize: '26px' } }}>
              <div style={{ display: "flex", justifyContent: "center", gap: 8, flexWrap: "wrap" }}>
                <Button
                  onClick={() => toggleMemberDisplay(user.id)}
                  className="btn btn-success"
                  style={{ height: '50px', fontSize: '12px' }}
                >
                  {selectedUserId === user.id ? 'Hide Members' : 'Show Members'}
                </Button>
                <Button
                  onClick={() => openAddMemberModal(user.id)}
                  className="btn btn-primary"
                  style={{ height: '50px', fontSize: '12px' }}
                >
                  Add Member
                </Button>
              </div>
            </td>
          </tr>
          {selectedUserId === user.id && user.members && user.members.map((member) => (
            
            <tr key={member.id}>
              <td></td>
              <td className="text-center" style={{ fontSize: '14px', '@media screen and (min-width: 576px)': { fontSize: '16px' }, '@media screen and (min-width: 768px)': { fontSize: '20px' }, '@media screen and (min-width: 992px)': { fontSize: '22px' }, '@media screen and (min-width: 1200px)': { fontSize: '24px' }, '@media screen and (min-width: 1400px)': { fontSize: '26px' } }}>{member.fullname || member.fullName || "-"}</td>
              <td className="text-center" style={{ fontSize: '14px', '@media screen and (min-width: 576px)': { fontSize: '16px' }, '@media screen and (min-width: 768px)': { fontSize: '20px' }, '@media screen and (min-width: 992px)': { fontSize: '22px' }, '@media screen and (min-width: 1200px)': { fontSize: '24px' }, '@media screen and (min-width: 1400px)': { fontSize: '26px' } }}>{member.gender}</td>
              <td className="text-center" style={{ fontSize: '14px', '@media screen and (min-width: 576px)': { fontSize: '16px' }, '@media screen and (min-width: 768px)': { fontSize: '20px' }, '@media screen and (min-width: 992px)': { fontSize: '22px' }, '@media screen and (min-width: 1200px)': { fontSize: '24px' }, '@media screen and (min-width: 1400px)': { fontSize: '26px' } }}>{formatDate(member.birthdate)}</td>
              <td className="text-center" style={{ fontSize: '14px', '@media screen and (min-width: 576px)': { fontSize: '16px' }, '@media screen and (min-width: 768px)': { fontSize: '20px' }, '@media screen and (min-width: 992px)': { fontSize: '22px' }, '@media screen and (min-width: 1200px)': { fontSize: '24px' }, '@media screen and (min-width: 1400px)': { fontSize: '26px' } }}>{member.nationality}</td>
              <td>
                <img
                  src={resolveImageSrc(member.image)}
                  alt={member.fullname}
                  style={{ width: '80px', height: '80px', objectFit: 'cover' }}
                />
              </td>
            </tr>
          ))}
        </Fragment>
      ))}
    </tbody>
  </Table>
</CardBody>

      </Card>

      <Modal isOpen={showStatsModal} toggle={() => setShowStatsModal(false)} centered>
        <ModalHeader toggle={() => setShowStatsModal(false)}>User Statistics</ModalHeader>
        <ModalBody>
          {(() => {
            const normalizeGender = (g) => (g || "").toLowerCase();
            const allPeople = [
              ...users.map((u) => ({
                gender: u.gender,
                birthdate: u.birthdate,
              })),
              ...users.flatMap((u) =>
                Array.isArray(u.members)
                  ? u.members.map((m) => ({
                      gender: m.gender,
                      birthdate: m.birthdate,
                    }))
                  : []
              ),
            ];
            const total = allPeople.length || 1;
            const maleCount = allPeople.filter(p => normalizeGender(p.gender) === "male").length;
            const femaleCount = allPeople.filter(p => normalizeGender(p.gender) === "female").length;

            const ageBuckets = [
              { label: "Under 18", min: 0, max: 17, count: 0 },
              { label: "18-24", min: 18, max: 24, count: 0 },
              { label: "25-34", min: 25, max: 34, count: 0 },
              { label: "35-44", min: 35, max: 44, count: 0 },
              { label: "45-54", min: 45, max: 54, count: 0 },
              { label: "55+", min: 55, max: 200, count: 0 },
            ];

            const getAge = (birthdate) => {
              if (!birthdate) return null;
              const d = new Date(birthdate);
              if (Number.isNaN(d.getTime())) return null;
              const today = new Date();
              let age = today.getFullYear() - d.getFullYear();
              const m = today.getMonth() - d.getMonth();
              if (m < 0 || (m === 0 && today.getDate() < d.getDate())) age--;
              return age;
            };

            allPeople.forEach((p) => {
              const age = getAge(p.birthdate);
              if (age === null) return;
              const bucket = ageBuckets.find(b => age >= b.min && age <= b.max);
              if (bucket) bucket.count += 1;
            });

            const genderChartData = {
              labels: ["Male", "Female"],
              datasets: [
                {
                  data: [maleCount, femaleCount],
                  backgroundColor: ["#4e73df", "#e83e8c"],
                  borderWidth: 0,
                },
              ],
            };

            const ageChartData = {
              labels: ageBuckets.map(b => b.label),
              datasets: [
                {
                  label: "Users",
                  data: ageBuckets.map(b => b.count),
                  backgroundColor: "#BCA464",
                  borderRadius: 6,
                },
              ],
            };

            return (
              <div>
                <div style={{ marginBottom: 24 }}>
                  <h6 style={{ marginBottom: 12 }}>Gender Distribution</h6>
                  <div style={{ maxWidth: 320, margin: "0 auto" }}>
                    <Doughnut
                      data={genderChartData}
                      options={{
                        responsive: true,
                        plugins: {
                          legend: { position: "bottom" },
                          tooltip: {
                            callbacks: {
                              label: (ctx) => {
                                const value = ctx.raw || 0;
                                const pct = Math.round((value / total) * 100);
                                return `${ctx.label}: ${value} (${pct}%)`;
                              },
                            },
                          },
                        },
                      }}
                    />
                  </div>
                </div>

                <div>
                  <h6 style={{ marginBottom: 12 }}>Age Distribution</h6>
                  <Bar
                    data={ageChartData}
                    options={{
                      responsive: true,
                      plugins: {
                        legend: { display: false },
                        tooltip: {
                          callbacks: {
                            label: (ctx) => {
                              const value = ctx.raw || 0;
                              const pct = Math.round((value / total) * 100);
                              return `${value} (${pct}%)`;
                            },
                          },
                        },
                      },
                      scales: {
                        x: { grid: { display: false } },
                        y: { beginAtZero: true, ticks: { precision: 0 } },
                      },
                    }}
                  />
                </div>
              </div>
            );
          })()}
        </ModalBody>
      </Modal>

      <Modal isOpen={isAddMemberModalOpen} toggle={closeAddMemberModal} centered>
        <ModalHeader toggle={closeAddMemberModal}>Add Member (Unlimited)</ModalHeader>
        <ModalBody>
          <Form onSubmit={handleAddMemberSubmit}>
            <FormGroup>
              <Input
                type="text"
                name="fullName"
                placeholder="Full Name"
                value={memberForm.fullName}
                onChange={handleMemberInputChange}
              />
            </FormGroup>
            <FormGroup>
              <Input
                type="select"
                name="gender"
                value={memberForm.gender}
                onChange={handleMemberInputChange}
              >
                <option value="">Select Gender</option>
                <option value="male">Male</option>
                <option value="female">Female</option>
              </Input>
            </FormGroup>
            <FormGroup>
              <Input
                type="date"
                name="birthdate"
                value={memberForm.birthdate}
                onChange={handleMemberInputChange}
              />
            </FormGroup>
            <FormGroup>
              <Input
                type="file"
                onChange={(e) => setMemberImage(e.target.files && e.target.files[0] ? e.target.files[0] : null)}
              />
            </FormGroup>
            {memberError ? (
              <div style={{ color: "#c0392b", marginBottom: 10 }}>{memberError}</div>
            ) : null}
            <ModalFooter>
              <Button color="primary" type="submit">
                Add Member
              </Button>
              <Button color="secondary" type="button" onClick={closeAddMemberModal}>
                Cancel
              </Button>
            </ModalFooter>
          </Form>
        </ModalBody>
      </Modal>
    </div>
  </>
  );
}

export default UserManagement;
